<template>
  <div>
    <heading><small>Privacy notice</small></heading>
    <p>
    We only collect the minimum amount of information that is required to
    support the functionality of WElix. No information is shared with third
    parties except in the cases listed below, or as required by law.
    </p>
    <p>
    In order to use the software you must consent to our data collection
    practices as they are described here. You can of course change your mind,
    and have the option to delete your account from the profile page at any
    time. If we make changes to how we collect or handle personal data we will
    ask for your consent again the next time you log in. If you have any
    questions about this notice or our data collection practices you can contact
    us by sending an email to <code>support@welix.no</code>.
    </p>

    <div class="policy-details">
      <h2>Personal data we collect</h2>
      <ul class="collection-list">
        <li>
          We ask for your <strong>email and name</strong> when you sign up. This
          information is available to WElix administrators and data owners, so
          that they can manage access to their databases. We will never send you
          emails that you have not requested except to notify you in the event
          of a security breach.
        </li>
        <li>
          We link the <strong>data you enter in WElix</strong> to your profile
          and display your name in the change log of each item you add or
          modify. The change log is visible to every user that has access to
          view those items.
        </li>
        <li>
          The first time you log in with a new device we collect your <strong>IP
            address</strong> and the <strong>browser and device</strong> you are
          using. This information is only used to provide you with a list of
          sessions on your profile page, and is intended as a way for you to
          check for unauthorized use of your account. We do not share this
          information with anyone.
        </li>
        <li>
          When you are logged in some of the <strong>system logs</strong> we
          collect are linked to your email address, so that we can more easily
          find logs relevant to your issue when you need support. These logs
          contain information about what you view and the actions you take in
          the system. They are not shared with anyone, and we do not keep these
          logs more than 6 months.
        </li>
      </ul>

      <h2>Account deletion</h2>
      <p>
      You can delete your account from the profile page at any time. Your user
      account will be completely deleted, along with your login history,
      IP addresses and browser sessions.
      </p>
      <p>
      However, your name and email address will continue to be associated with
      data you have entered. This is required in order to maintain a full
      historical account of the information in WElix.
      </p>
    </div>
  </div>
</template>

<script>
import Heading from './elements/Heading';

export default {
  components: {
    Heading,
  },

  data() {
    return {};
  },
};
</script>

<style scoped>
.policy-details {
  font-size: 85%;
}
.collection-list {
  padding-left: 12px;
}
.collection-list li {
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyNotice.vue